<template>
    <div >
        <vs-popup title="Lista de Pedidos Selecionados" :active.sync="popUpSelecao.popupActive">
            <vs-alert color="danger" :active.sync="popUpSelecao.exibirMensagem" closable icon-pack="feather" close-icon="icon-x" class="mb-3" icon="icon-info">
                {{popUpSelecao.mensagem}}
            </vs-alert> 
           <vs-table :data="listaPedidosSelecionados" pagination max-items="5" noDataText="Nenhum pedido selecionado." stripe search>
              <template slot="thead">
                  <vs-th>PEDIDO</vs-th>
                  <vs-th>DATA</vs-th>            
                  <vs-th><span class="w-full" style="text-align:center !important;"> VENDEDOR </span></vs-th>            
                  <vs-th></vs-th>  
              </template>

              <template slot-scope="{data}"> 
                  <vs-tr :key="tr.id" v-for="(tr) in data" :data="tr">
                      <vs-td :data="tr.numeroPedido"  style="padding: 1px;">
                          <small>{{tr.numeroPedido}}</small>                   
                      </vs-td>
                      <vs-td :data="tr.dataPedidoFormatada"  style="padding: 1px;">
                          <small>{{tr.dataPedidoFormatada}}</small>
                      </vs-td>   
                      <vs-td :data="tr.nomeVendedor"  style="padding: 1px;" class="text-center">
                          <small>{{tr.nomeVendedor}}</small>
                      </vs-td>   
                      <vs-td :data="tr.dataPedidoFormatada"  style="padding: 1px;">
                          <vs-button size="small" color="danger" icon-pack="feather" icon="icon-minus" @click="removerPedido(tr)"></vs-button>             
                      </vs-td>
                  </vs-tr>
              </template>
            </vs-table> 
            <vx-input-group>
                <template slot="prepend">
                <div class="prepend-text bg-primary">
                    <vs-button color="primary" icon-pack="feather" icon="icon-tag" @click="gerarNumeroCarregamento"></vs-button>
                </div>
                </template>
                <vs-input v-model="popUpSelecao.numeroCarregamento" placeholder="Número do Carregamento" class="w-full" />
            </vx-input-group>
            <vs-row vs-type="flex" vs-justify="space-between" class="mt-4">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                    <vs-button color="dark" @click="enviarRequisicao(ACAO_CRIAR_CARREGAMENTO)" :disabled="!listaPedidosSelecionados.length || !popUpSelecao.numeroCarregamento"><small>Criar Carregamento </small></vs-button>
                    <vs-button color="dark" @click="enviarRequisicao(ACAO_RELIBERAR_PARA_ROTEIRIZACAO)" class="ml-2" :disabled="!listaPedidosSelecionados.length"><small>Liberar para Roteirização</small></vs-button>
                    <vs-button color="dark" @click="enviarRequisicao(ACAO_RELIBERAR_PARA_SEPARACAO)" class="ml-2" :disabled="!listaPedidosSelecionados.length "> <small>Liberar para Separação</small></vs-button>
                    <vs-button color="warning" @click="limparListaSelecao" class="ml-2" :disabled="!listaPedidosSelecionados.length" icon="clear"> </vs-button>
                </vs-col>
            </vs-row>
        </vs-popup>  
        <div class="flex mb-2">
            <div class="flex items-center">
              <p class="text-sm font-medium"> Pedidos Não Liberados para Separação: <strong>{{dadosDaGrid.length}}</strong> pedidos. </p>
              <vs-checkbox class="text-sm ml-4" size="small" v-model="filtroInner.exibirApenasAtrasados">Pedidos Atrasados: <strong>{{qtdPedidosAtrasados}} </strong></vs-checkbox>  
            </div>
            <div class="flex items-center ml-auto">
              <feather-icon icon="ShoppingCartIcon" class="cursor-pointer ml-4 mr-6" :badge="listaPedidosSelecionados.length" @click="abrirPopUpSelecao" v-if="!$store.state.AppActiveUser.hasOwnProperty('idVendedor')"/>
              <vs-button size="small" class="ml-2" color="dark" icon="color_lens" v-if="false"></vs-button>
              <vs-button size="small" class="ml-2" color="dark" icon="cloud_download" @click="exportarParaCSV" ></vs-button>
              <vs-button size="small" class="ml-2" color="dark" icon="add" @click="adicionarTodos" v-if="!$store.state.AppActiveUser.hasOwnProperty('idVendedor')"></vs-button>
            </div>
        </div>
        <ag-grid-vue
          ref="agGridTable"           
          :gridOptions="grid.gridOptions"
          class="ag-theme-material ag-grid-table ag-grid-altura"
          :columnDefs="grid.columnDefs"
          :defaultColDef="grid.defaultColDef"
          :rowData="listaPedidosFiltrada"
          :headerHeight="25"
          :rowHeight="25"
          rowSelection="single"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="false"
          :pagination="false"    
          :context="grid.context"        
          >
        </ag-grid-vue>
    </div>
</template>

<script>
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/concept/scss/tabelaBasica.scss'
import BtnAggridComponentRenderer from './BtnAggridComponent.vue';
import AvatarStatusImportacaoPedidoRenderer  from './AvatarStatusImportacaoPedido.vue';
import generico from '@/generico.js'

const URL_SERVLET = "/PedidosRotasRestServlet";
const ACAO_CRIAR_CARREGAMENTO = "CRIAR_CARREGAMENTO";
const ACAO_RELIBERAR_PARA_ROTEIRIZACAO = "RELIBERAR_PARA_ROTEIRIZACAO";
const ACAO_RELIBERAR_PARA_SEPARACAO = "RELIBERAR_PARA_SEPARACAO";

export default {
  components: {
    AgGridVue
  },
  created() {
      this.ACAO_CRIAR_CARREGAMENTO = ACAO_CRIAR_CARREGAMENTO;
      this.ACAO_RELIBERAR_PARA_ROTEIRIZACAO = ACAO_RELIBERAR_PARA_ROTEIRIZACAO;
      this.ACAO_RELIBERAR_PARA_SEPARACAO = ACAO_RELIBERAR_PARA_SEPARACAO;
  },
  props: {
      filtro: {
          type: Object,
          default: function () {
            return {vendedor: null, loja: null, zona: null, numeroPedido: null, numeroCarregamento: null, tipoDataPesquisa: 'VENDA', dataInicio: null,
                dataFim: null};
          }
       }
  },
  computed: {
     temCapacidadeMaster(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.capacidadeMaster;
      }
      return false;
    },
    temPermissaoGravar(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.grupoPodeSeAlterar;
      }
      return false;
    },
    isAcessoMaster() {
        return this.$store.getters.isAcessoMaster;
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    }, 
    listaPedidosFiltrada() {
        var self = this;
        var arrayRetorno = self.dadosDaGrid;

        if (self.filtroInner.exibirApenasAtrasados) {        
            arrayRetorno = arrayRetorno.filter(function (p) {
                return p.hasOwnProperty('compromissoEntregaAtrasado');
            })
        }

        return arrayRetorno;
    },
    qtdPedidosAtrasados() {
      var resutlado = this.dadosDaGrid.filter(function (p) {
         return p.hasOwnProperty('compromissoEntregaAtrasado');
      });

      return resutlado.length;
    }
  },
  data() {
    return {
        popUpSelecao : {
            popupActive: false,
            exibirMensagem: false,
            mensagem: null,
            numeroCarregamento: null
        },
        dadosDaGrid: [],
        filtroInner: {exibirApenasAtrasados: false},
        grid: { 
          context: null, 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [     
            { headerName: '' , field: 'numero', cellRendererFramework: BtnAggridComponentRenderer, colId: 'params', editable: false, width: 40},     
            { headerName: '' , field: 'numero', cellRendererFramework: AvatarStatusImportacaoPedidoRenderer, colId: 'params_2', editable: false, width: 35},        
            { headerName: 'PEDIDO', field: 'numeroPedido', width: 90 },    
            { headerName: 'CLIENTE', field: 'nomePontoInteresse', width: 200 },                                                       
            { headerName: 'DATA VENDA', field: 'dataPedidoFormatada', width: 130, valueGetter : function(params) {
                return params.data.dataPedidoFormatada + " " + params.data.horaPedido;
            } },                          
            { headerName: 'COMPROMISSO', field: 'nome', width: 150 , cellRenderer : function(params) {
                  if (params.data.hasOwnProperty('dataHoraCompromissoEntregaFormatada')) {
                      return params.data.dataHoraCompromissoEntregaFormatada + (params.data.hasOwnProperty('dataHoraRenegociacaoEntregaFormatada') ?  ' <br/>' + params.data.dataHoraRenegociacaoEntregaFormatada : ''); 
                  } else {
                    return '';
                  }
                } 
            },
            { headerName: 'VENDEDOR', field: 'nomeVendedor', width: 150 },                 
            { headerName: 'LOJA', field: 'nomeLoja', width: 150 },                 
            { headerName: 'ZONA', field: 'nomeZona', width: 150 },            
            { headerName: 'PESO', field: 'peso', width: 150, valueGetter : function(params) {
                    return generico.formatarNumero(params.data.peso);
            } },            
            { headerName: 'VOLUME', field: 'volume', width: 150 , valueGetter : function(params) {
                    return generico.formatarNumero3Decimais(params.data.volume);
            } },
            { headerName: 'VALOR', field: 'valorPedidoFormatado', width: 150 },    
            { headerName: 'CARREGAMENTO', width: 110,  field: 'numeroCarregamento' },
            { headerName: 'OBSERVAÇÃO', width: 110,  field: 'observacaoPedido' },
          ]
        },
        listaPedidosSelecionados: [],
    }
  },
  methods :{
    fetchLista(filtro) {  
        this.$vs.loading();    
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        params.append('gerenciamentoPedidos-Aba6', true);
        
        if (filtro.numeroPedido) {
            params.append('filter2', filtro.numeroPedido);
            params.append('numeroPedido', filtro.numeroPedido);
        } else if (filtro.dataInicio) {                
            params.append('campoData', filtro.tipoDataPesquisa);
            params.append('dataInicio', filtro.dataInicio*1000);
            params.append('dataFim', filtro.dataFim*1000);
            params.append('semCelular', this.filtroInner.exibirSomenteSemCelular);

            if (filtro.numeroPedido) {
                params.append('filter2', filtro.numeroPedido);
                params.append('numeroPedido', filtro.numeroPedido);
            }

            if (filtro.numeroCarregamento) {
                params.append('numeroCarregamento', filtro.numeroCarregamento);          
            }
            
        } else {
            if (filtro.numeroCarregamento) {
                params.append('numeroCarregamento', filtro.numeroCarregamento);          
            }

            if (filtro.numeroLote) {
                params.append('numeroLote', filtro.numeroLote);          
            }
        }

        if (filtro.zona) {
            params.append('idZona', filtro.zona.id);
        }

        if (filtro.loja) {
            params.append('idLoja', filtro.loja.id);
        }

        if (filtro.vendedor) {
            params.append('idVendedor', filtro.vendedor.id);
        }

        axios.post(URL_SERVLET, params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {
                this.dadosDaGrid = response.data;        
                this.totalRegistros = this.dadosDaGrid.length;                    
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetch Lista Despesas - " + error); 
        })    
                        
    },
    adcionarPedido(pedido) {
        if (this.listaPedidosSelecionados.indexOf(pedido) === -1) {
            this.listaPedidosSelecionados.push(pedido);
        } else {
            this.$vs.dialog({color:'danger', title: 'Atenção', 
            text: 'Pedido já incluído',
            acceptText:'OK'
      }) 
        }
    },
    removerPedido(pItem) {
        this.listaPedidosSelecionados.splice(this.listaPedidosSelecionados.indexOf(pItem), 1);
        
    },
    abrirPopUpSelecao() {
        this.popUpSelecao.popupActive = true;
    },
    adicionarTodos() {
        if (Array.isArray(this.dadosDaGrid)) {
            this.listaPedidosSelecionados.push(...this.dadosDaGrid);
        } else {
            this.listaPedidosSelecionados.push(this.dadosDaGrid);
        }
    },
    limparListaSelecao() {
        this.listaPedidosSelecionados = null;
        this.listaPedidosSelecionados = [];
    },
    enviarRequisicao(acao) {

        if (!this.temPermissaoGravar && !this.temCapacidadeMaster) {
            this.$vs.notify({
                    time:8000, title: "Atenção",  text: "Você não ter permissão.",
                    iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger'
            });

            return;
        }
        
        this.$vs.loading()
        
        var listIdPedidos = null;

        for (var i= 0; i < this.listaPedidosSelecionados.length; i++){
            if (listIdPedidos === null) {
                listIdPedidos = new String();
                listIdPedidos = listIdPedidos + this.listaPedidosSelecionados[i].id;
            } else {
                listIdPedidos = listIdPedidos + "," + this.listaPedidosSelecionados[i].id;
            }
        }

        const params = new URLSearchParams();
        params.append('outputFormat', 'JSON');
        params.append('method', acao);
        params.append('idCliente', this.$store.state.AppActiveUser.id);  
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa); 

        if (this.popUpSelecao.numeroCarregamento) {
            params.append('numeroCarregamento', this.popUpSelecao.numeroCarregamento);	
        }
        params.append('listaIDs', listIdPedidos);
        
        axios.post("/PedidosRotasRestServlet", params, {              
            credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                    
                this.popUpSelecao.popupActive = false;       

                this.$vs.notify({
                    time:8000, title: "Atenção",  text: response.data.mensagem,
                    iconPack: 'feather', icon: 'icon-alert-circle', color: 'success'
                });
                
                if (acao !== ACAO_CRIAR_CARREGAMENTO) {
                    this.limparListaSelecao();
                }

                this.fetchLista(this.filtro);
                                    
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    exportarParaCSV() {
      this.grid.gridApi.exportDataAsCsv({fileName: 'Grid6.csv'});
    },
    gerarNumeroCarregamento() {
        this.popUpSelecao.numeroCarregamento = generico.criarNumeroCarregamento();
    }
  },
  beforeMount() {
     this.grid.context = { componentParent: this };    
  },
  mounted(){
       this.grid.gridApi = this.grid.gridOptions.api;
       this.grid.gridApi.sizeColumnsToFit();  
       if (this.$store.state.AppActiveUser.hasOwnProperty('idVendedor')) {
            this.grid.gridOptions.columnApi.setColumnVisible("params", false); 
       } else {
            this.grid.gridOptions.columnApi.setColumnVisible("params", true); 
       }
       this.fetchLista(this.filtro);
  }
}
</script>

<style lang="scss">
  .ag-grid-altura{
    height: calc(100vh - 280px);
  }
</style>